"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RoofingSystems() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const systems = [{
    title: "North Ridge Slate Steel Shingles\xA0",
    category: "LUXURY TRADITION",
    price: "From $17 / sq ft",
    description: "Mimics the heavy profile of natural slate without the extreme weight. Provides a sophisticated, high-end finish for luxury estates in Okotoks.",
    feature1: "Deep-shadow profile for depth",
    feature2: "Interlocking panels for wind resistance",
    feature3: "Available in multiple slate tones",
    image: "https://7oo.ca/wp-content/uploads/2026/07/North-Ridge-Slate-S_image.png?v=gdiommp8qkc",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/North-Ridge-Slate.png?v=30ajxa9kioi-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/North-Ridge-Slate.png?v=ypqgw9hg6q-wvc-sizes",
    alt: "North Ridge Slate metal roofing installation"
  }, {
    title: "Cedar Creek Shake\xA0 Steel Shingles",
    category: "NATURAL AESTHETIC",
    price: "From $16 / sq ft",
    description: "The rustic charm of wood shake combined with the permanent durability of metal. A perfect solution for mountain-inspired architecture in Airdrie and Cochrane.",
    feature1: "Authentic wood grain texture",
    feature2: "Non-combustible fire resistance",
    feature3: "Zero maintenance compared to wood",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-Creek-Shake_image.png?v=uzinz58mr99",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-Creek-Shake-Steel-Shingles.png?v=ge4n4pzy51-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Cedar-Creek-Shake-Steel-Shingles.png?v=i95ldmhc13r-wvc-sizes",
    alt: "Cedar Creek Shake steel roofing on a luxury residential home"
  }, {
    title: "Stone Coated Shingles",
    category: "RESILIENT CLASSIC",
    price: "From $14 / sq ft",
    description: "Get the timeless look of slate or shake with the structural integrity of steel. Engineered to withstand Calgary's harshest hail and wind conditions.",
    feature1: "Impact-resistant Class 4 rating",
    feature2: "Lightweight design reduces structural load",
    feature3: "Fade-resistant stone granule coating",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Coated-Shingle_image.png?v=56s9r6gt4p6",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Coated-Shingles.png?v=uoq6ycfhxh9-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Stone-Coated-Shingles.png?v=57n0momjuvs-wvc-sizes",
    alt: "Complete modern luxury residential home with BTR Polar stone-coated steel roofing"
  }, {
    title: "Standing Seam Metal",
    category: "PREMIUM ARCHITECTURAL",
    price: "From $18 / sq ft",
    description: "The gold standard in architectural roofing. Concealed fasteners and clean, vertical lines provide unmatched weather protection and a modern aesthetic for Calgary homes.",
    feature1: "Hidden fastener system for leak prevention",
    feature2: "High-grade Kynar 500 finish",
    feature3: "Lifetime residential warranty",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/standing_seam_roof.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/standing_seam_roof.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/standing_seam_roof.png-wvc-sizes",
    alt: "Premium standing seam metal roof installation on a modern home"
  }, {
    title: "Professional Installation",
    category: "EXPERT CRAFT",
    price: "Guaranteed Quality",
    description: "Our certified installation teams ensure your metal roof is installed to the highest industry standards for maximum longevity and performance.",
    feature1: "Certified master installers",
    feature2: "Safety-first project management",
    feature3: "Comprehensive post-install inspection",
    image: "https://7oo.ca/wp-content/uploads/2026/07/Prof-Installation-Calgary-2026.png?v=vy7v2v3k8e",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Professional-Installation.png?v=25v7ebi07pv-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Professional-Installation.png?v=ay7xx8sfrip-wvc-sizes",
    alt: "Professional metal roofing installation team at work"
  }];
  return <section data-section-id="1148" id="premium-roofing-systems" ref={sectionRef} className="relative overflow-hidden bg-background text-foreground light ![padding:0px_0px_50px_0px]">
      <div className="absolute left-1/2 top-0 h-full w-px bg-border/10 hidden lg:block" />

      <div className="relative mx-auto max-w-[1440px] px-6">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-32">
          
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <div className={`transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
                <Button asChild variant="outline" size="lg" className="w-full min-h-[48px] sm:w-auto rounded-lg border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground">
                  
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-12 lg:col-span-7">
            {systems.map((system, i) => <Card key={i} data-index={i} className={`group relative overflow-hidden border-border/50 bg-background text-foreground transition-all duration-700 hover:scale-[1.02] hover:border-primary/50 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="relative overflow-hidden aspect-[4/5] md:aspect-auto">
                    <img src={system.image} data-wvc-srcset={system.srcset} data-wvc-sizes={system.sizes} alt={system.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>

                  <div className="flex flex-col justify-between p-6 lg:p-10">
                    <div>
                      <span className="font-mono text-[10px] font-bold tracking-widest text-muted-foreground uppercase break-words">
                        {system.category}
                      </span>
                      <h3 className="mt-4 text-2xl font-bold tracking-tight lg:text-3xl break-words">
                        {system.title}
                      </h3>
                      <p className="mt-4 text-sm leading-relaxed text-muted-foreground break-words">
                        {system.description}
                      </p>
                      
                      <ul className="mt-8 space-y-3">
                        {[system.feature1, system.feature2, system.feature3].map((feature, fi) => <li key={fi} className="flex items-center gap-3 text-xs font-medium">
                            <div className="h-1 w-1 bg-primary" />
                            {feature}
                          </li>)}
                      </ul>
                    </div>

                    <div className="mt-10">
                      <Button asChild size="lg" className="w-full min-h-[48px] rounded-lg bg-primary text-primary-foreground hover:bg-primary/90">
                        <Link to="https://metallineexteriors.ca/contact/">Request Quote</Link>
                      </Button>
                    </div>
                  </div>
                </div>
                
                <div className="absolute -bottom-1 -right-1 h-2 w-2 bg-primary opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}